/**
 * {
	"messageType": "alertNotification",
	"notificationId": 1645477756788,
	"notificationDetails": {"updateType":"EXIT_TRIGGERED","notificationType":"TRADE_PLAN_UPDATE","TRADE_PLAN":{"type":"BASIC_TRADING_SYSTEM","id":1,"symbol":"XYZ"}},
	"status": "TACTIC_TRIGGERED",
	"statusDetails": {"pluginTemplate":{"candlesBack":14,"atrValue":1.0,"atrType":"WILDER","candleDuration":1,"timeUnit":"MINUTES"},"triggerPrice":100.0,"tradeDirection":"LONG","tacticName":"ATR_TRAIL","symbol":"XYZ"},
	"date": "2022-02-21T16:09:17.920-0500",
	"timestamp": "1645477757926"
}

 * @param {*} pluginTemplate 
 * @returns object with fields:
 * 1) candlesBack
 * 2) atrValue (size of atr)
 * 3) candleDuration
 * 4) timeUnit
 * 5) atrType (WILDERS, SMA, etc)
 */
export function atrTrailParser(pluginTemplate) {
  const parsedObject = {
    candlesBack: null,
    atrValue: null,
    candleDuration: null,
    timeUnit: null,
    atrType: null,
  };
  if (pluginTemplate) {
    parsedObject.candlesBack = pluginTemplate.candlesBack;
    parsedObject.atrValue = pluginTemplate.atrValue;
    parsedObject.candleDuration = pluginTemplate.candleDuration;
    parsedObject.timeUnit = pluginTemplate.timeUnit;
    parsedObject.atrType = pluginTemplate.atrType;
  }
  return parsedObject;
}
